// extracted by mini-css-extract-plugin
module.exports = {"RulesList":"RulesList_RulesList__1OJGO"};